
import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ManualItemCriteriaModel, ManualItemModel, SearchELiManualModel, SearchManualModel } from 'src/app/core/models/manual/manual.model';
import { PageRequestModel, PageResponseModel } from 'src/app/core/models/page.model';

import { ManualService } from 'src/app/core/services/manual/manual.service';
import { PaginatorComponent } from 'src/app/shared/components/paginator/paginator.component';


import { MatTableDataSource } from '@angular/material/table';
import { LinkManualItemCriteriaModel, LinkManualItemModel, SearchELiLinkManualModel } from 'src/app/core/models/link-manual/link-manual.model';
import { LinkManualService } from 'src/app/core/services/link-manual/link-manual.service';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.scss'],
})
export class ManualComponent implements OnInit {
  @ViewChild('pagination', { static: false }) pagination!: PaginatorComponent;
  @ViewChild('pagination', { static: false }) paginationLink!: PaginatorComponent;

  //SearchELiManualModel
  pageRequest2: PageRequestModel<SearchELiManualModel> =    new PageRequestModel<SearchELiManualModel>();
  pageRequest: PageRequestModel<ManualItemCriteriaModel> =    new PageRequestModel<ManualItemCriteriaModel>();
  pageResponse: PageResponseModel<ManualItemModel> =    new PageResponseModel<ManualItemModel>();

  items: ManualItemModel[] = [];
  dataSource: any;

  previousDate: Date = new Date();

  pageRequestLink2: PageRequestModel<SearchELiLinkManualModel> =     new PageRequestModel<SearchELiLinkManualModel>();
  pageRequestLink: PageRequestModel<LinkManualItemCriteriaModel> =    new PageRequestModel<LinkManualItemCriteriaModel>();
  pageResponseLink: PageResponseModel<LinkManualItemModel> =    new PageResponseModel<LinkManualItemModel>();

  itemsLink: LinkManualItemModel[] = [];
  dataSourceLink: any;

  previousDateLink: Date = new Date();

  constructor(
    private service: ManualService,
    private serviceLink: LinkManualService,
    private titleService: Title,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translateService.instant('คู่มือ'));

    this.pageRequest = PageRequestModel.createFirst(ManualItemCriteriaModel);

    this.pageRequestLink = PageRequestModel.createFirst(LinkManualItemCriteriaModel);

    this.loadDataList();
    this.loadDataListLink();
    //this.pagination.setPageResult(this.pageResult);
  }

  async loadDataList() {
    const response = await this.service.search(this.pageRequest);

    this.pageResponse = response;
    this.items = this.pageResponse.items;
    this.pagination.setPageResult(this.pageResponse);

    this.dataSource = new MatTableDataSource<ManualItemModel>(this.items);
  }

  async loadDataListLink() {
    //<=======================
    const responseLink = await this.serviceLink.search(this.pageRequestLink);
    this.pageResponseLink = responseLink;
    this.itemsLink = this.pageResponseLink.items;
    this.paginationLink.setPageResult(this.pageResponseLink);
    this.dataSourceLink = new MatTableDataSource<LinkManualItemModel>(this.itemsLink);
  }

  onPageChange(page: number) {
    this.pageRequest.pageNumber = page;
    this.loadDataList();
  }

  onPageSizeChange(value: any) {
    this.pageRequest.pageNumber = 1;
    this.pageResponse.pageSize = value.target.value;
    this.loadDataList();
  }

  download(url: string) {
    // const beforUrl: string = 'https://elitigationdev.admincourt.go.th/admELitigation'

    // url = beforUrl + url.substring(2)
    // //this.url = this.url.replaced(/(\r\n|\n|\r)/gm, '<br />');

    console.log(url);
    var win = window.open(url, '_blank')!;
    win.focus();
  }

  detailMu(detail: string) {
    var output = detail.replace(/(?:\r\n|\r|\n)/g, '\\n');
  }

  search() {
    // const value = (data.target as HTMLInputElement).value;
    console.log(this.pageRequest.criteria.detail);

    this.pageRequest2.sort;

    if (this.pageRequest.criteria.detail.length > 2) {
      this.previousDate = new Date();
      const that = this;
      setTimeout(function () {
        const currentTime = new Date();
        const diffSecond =
          currentTime.getSeconds() - that.previousDate.getSeconds();
        const diffSecond2 =
          currentTime.getMilliseconds() - that.previousDate.getMilliseconds();
        if (diffSecond * 1000 + diffSecond2 >= 1000) {
          that.pageRequest.pageNumber = 1;
          that.loadDataList();
        }
      }, 1000);
    } else if (this.pageRequest.criteria.detail.length == 0) {
      this.previousDate = new Date();
      const that = this;
      setTimeout(function () {
        const currentTime = new Date();
        const diffSecond =
          currentTime.getSeconds() - that.previousDate.getSeconds();
        const diffSecond2 =
          currentTime.getMilliseconds() - that.previousDate.getMilliseconds();
        if (diffSecond * 1000 + diffSecond2 >= 1000) {
          that.pageRequest.pageNumber = 1;
          that.loadDataList();
        }
      }, 1000);
    }
    /*const value = (data.target as HTMLInputElement).value;
    console.log(value);
    
    this.dataSource.filter = value;*/
  }

//------------------- Link


onPageChangeLink(page: number) {
  this.pageRequestLink.pageNumber = page;
  this.loadDataListLink();
}

onPageSizeChangeLink(value: any) {
  this.pageRequestLink.pageNumber = 1;
  this.pageResponseLink.pageSize = value.target.value;
  this.loadDataListLink();
}

searchLink() {
    console.log(this.pageRequestLink.criteria.detail);

    this.pageRequestLink2.sort;

    if (this.pageRequestLink.criteria.detail.length > 2) {
      this.previousDateLink= new Date();
      const that = this;
      setTimeout(function () {
        const currentTime = new Date();
        const diffSecond =
          currentTime.getSeconds() - that.previousDateLink.getSeconds();
        const diffSecond2 =
          currentTime.getMilliseconds() - that.previousDateLink.getMilliseconds();
        if (diffSecond * 1000 + diffSecond2 >= 1000) {
          that.pageRequestLink.pageNumber = 1;
          that.loadDataListLink();
        }
      }, 1000);
    } else if (this.pageRequestLink.criteria.detail.length == 0) {
      this.previousDateLink= new Date();
      const that = this;
      setTimeout(function () {
        const currentTime = new Date();
        const diffSecond =  currentTime.getSeconds() - that.previousDateLink.getSeconds();
        const diffSecond2 = currentTime.getMilliseconds() - that.previousDateLink.getMilliseconds();
        if (diffSecond * 1000 + diffSecond2 >= 1000) {
          that.pageRequestLink.pageNumber = 1;
          that.loadDataListLink();
        }
      }, 1000);
    }

  }

}
